<template>
  <v-select
    :items="propProfiles.map(x => x.CustomerNumber)"
    label="Kundennumer"
    :value="getCustomerNumber()"
    @change="(item) => this.setCustomerNumber(item)"
    outlined
    :loading="!propLoaded"
  >
    <template v-slot:selection="{ item }">
      <v-badge
        avatar
        overlap
        bottom
        class="mr-5"
      >
        <template v-slot:badge>
          <v-avatar color="white">
            <v-img src="@/assets/erp-icons/icrm.png"></v-img>
          </v-avatar>
        </template>
        <v-avatar color="indigo" size="32">
          <v-icon dark>mdi-account</v-icon>
        </v-avatar>
      </v-badge>
      <span>{{ formatCustomerForSelector(item) }}</span>
    </template>
    <template v-slot:item="{ item }">
      <v-badge
        avatar
        overlap
        bottom
        class="mr-5"
      >
        <template v-slot:badge>
          <v-avatar color="white">
            <v-img :src="require('@/assets/erp-icons/icrm.png')"></v-img>
          </v-avatar>
        </template>
        <v-avatar color="indigo" size="40">
          <v-icon dark>mdi-account</v-icon>
        </v-avatar>
      </v-badge>
      <span>{{ formatCustomerForSelector(item) }}</span>
    </template>
  </v-select>
</template>

<script>
//
// Handles the account selection if multiple customer numbers
// are assigned to one email address.
// 
// A change on the customer number will be visible via Vuex
// (store) and can be watched on.
//
import { Customer } from '../plugins/CustomerPortalApiClient/types';

export default {
  name: 'account-selector',
  props: {
    profiles: { type: Array },
    loaded: { type: Boolean },
  },
  computed: {
    /**
     * @returns {Customer[]}
     */
    propProfiles() {
      return this.profiles;
    },
    /**
     * @returns {Boolean}
     */
    propLoaded() {
      return this.loaded;
    },
  },
  methods: {
    formatCustomerForSelector(customerNumber) {
      let customer = this.propProfiles.find(x => x.CustomerNumber == customerNumber);
      return `${customer.FamilyName} ${customer.FirstName} (${customer.CustomerNumber})`;
    },
    usageForTypeOnlyImports() {
      new Customer();
    },
    /**
     * @returns {String}
     */
    getCustomerNumber() {
      return this.$store.getters.customerNumber();
    },
    /**
     * @returns {Void}
     */
    setCustomerNumber(value) {
      this.$store.commit('customerNumber', value);
    }
  }
}
</script>